// src/dashboard/Help.jsx

import React from 'react';
import { useIntl } from 'react-intl';
import { BookOpen, LifeBuoy, ExternalLink } from 'lucide-react';

export default function Help() {
  const intl = useIntl();

  const handleOpenDocs = () => {
    // TODO: ajuste a URL da documentação se necessário
    window.open('https://docs.lugarai.com', '_blank', 'noopener');
  };

  const handleContactSupport = () => {
    // Preferência: abrir e-mail. Se usar WhatsApp/HelpDesk, troque aqui.
    const subject = encodeURIComponent('[lugarAI] Suporte');
    const body = encodeURIComponent('Descreva seu problema aqui. Inclua prints quando possível.');
    window.location.href = `mailto:support@lugarai.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="la dashboard-page">
      <div className="dashboard-content">
        {/* Header */}
        <div className="dashboard-header">
          <div className="header-left">
            <h2 className="page-title">
              {intl.formatMessage({ id: 'page.help.title', defaultMessage: 'Ajuda' })}
            </h2>
            <div className="page-subtitle muted">
              {intl.formatMessage({
                id: 'page.help.subtitle',
                defaultMessage: 'Encontre a documentação e canais de suporte do lugarAI.',
              })}
            </div>
          </div>
        </div>

        {/* Card: Documentação */}
        <div className="card mb-16">
          <div className="row center gap-10">
            <BookOpen size={18} />
            <h3 className="section-title">
              {intl.formatMessage({ id: 'page.help.docs.title', defaultMessage: 'Documentação' })}
            </h3>
          </div>
          <p className="subtitle-muted mt-16">
            {intl.formatMessage({
              id: 'page.help.docs.desc',
              defaultMessage: 'Acesse os guias de configuração, tutoriais e referências técnicas.',
            })}
          </p>
          <div className="mt-16">
            <button className="primary-button" onClick={handleOpenDocs}>
              <ExternalLink size={16} style={{ marginRight: 8 }} />
              {intl.formatMessage({ id: 'actions.openDocs', defaultMessage: 'Abrir documentação' })}
            </button>
          </div>
        </div>

        {/* Card: Suporte */}
        <div className="card">
          <div className="row center gap-10">
            <LifeBuoy size={18} />
            <h3 className="section-title">
              {intl.formatMessage({ id: 'page.help.support.title', defaultMessage: 'Suporte' })}
            </h3>
          </div>
          <p className="subtitle-muted mt-16">
            {intl.formatMessage({
              id: 'page.help.support.desc',
              defaultMessage:
                'Fale com nossa equipe para resolver dúvidas, problemas técnicos e solicitações.',
            })}
          </p>
          <div className="mt-16">
            <button className="secondary-button" onClick={handleContactSupport}>
              <LifeBuoy size={16} style={{ marginRight: 8 }} />
              {intl.formatMessage({ id: 'actions.contactSupport', defaultMessage: 'Contatar suporte' })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
